import {
    getCookie,
    setCookie,
    initSwiper,
    renderCSS,
    renderElements,
    renderElementsPackContainer,
    renderElementsMiniContainer,
    renderForm,
    implantRate,
    checkTitlesMargin,
    addHiddenContent,
} from './widereview/widereview';

import {
    implantAppMini,
} from './widereview/miniSlider';

import {
    watchEventPackHiddenReviews,
    adaptPackImg,
    initMasonry
} from './widereview/packContainer';

import {
    plugWeglot,
} from './libraryCompatibleApp';

import {
    addRateParentFlexWrap,
    addOverflowForminiParent
} from './utils';

import '../scss/widereview.scss';

if (window.WIDEREVIEW == undefined) {
window.WIDEREVIEW = {
	Containers:{}
};

function preRenderCarousel() {
	let appContainer, product_id;

	if (document.getElementById('widereview-module') != null) {
		appContainer = document.getElementById('widereview-module');
	} else if (document.getElementById('widereview') != null) {
		appContainer = document.getElementById('widereview');
	} else if (document.getElementById('widereview-liquid') != null) {
		appContainer = document.getElementById('widereview-liquid');
	} else {
		appContainer = '';
	}

	if (!appContainer) return {};

	window.WIDEREVIEW.Containers.Carousel = appContainer;
	product_id = determLocation (appContainer);

	window.WIDEREVIEW.url_get_form = getUrlApp () + '/api/get_form?product_id=' + window.WIDEREVIEW.form_product_id + '&shop=' + window.WIDEREVIEW.shop + '&shop_domain=' + window.location.hostname;

	return {carousel: product_id};
}

async function renderCarousel() {

	if (window.WIDEREVIEW.options.enabled === false ) return;
	if (window.WIDEREVIEW.options.enabled_product_page === false && (typeof meta != "undefined" && meta.page.pageType === 'product' || typeof window.WIDEREVIEW_META != "undefined" && window.WIDEREVIEW_META.page.pageType === 'product')) return;
	if (window.WIDEREVIEW.options.enabled_homePage === false && (typeof meta != "undefined" && meta.page.pageType == 'home' || typeof window.WIDEREVIEW_META != "undefined" && window.WIDEREVIEW_META.page.pageType == 'home')) return;

	renderCSS(window.WIDEREVIEW.options);

    renderElements(window.WIDEREVIEW.Containers.Carousel, window.WIDEREVIEW.render.Carousel.reviews, window.WIDEREVIEW.options);
    checkTitlesMargin ();
    initSwiper(null, window.WIDEREVIEW.render.Carousel.reviews.length, window.WIDEREVIEW.options, window.WIDEREVIEW.render.Carousel.reviews);
	renderForm(window.WIDEREVIEW.Containers.Carousel, window.WIDEREVIEW.options, window.WIDEREVIEW);
}

function preRenderRate() {

    let products = {};

    document.querySelectorAll('.widereview-rate').forEach(function (elem) {
       if(elem.hasAttribute('widereview-rate-product-id')){
           products[elem.getAttribute('widereview-rate-product-id')] = elem.getAttribute('widereview-rate-product-id');
       }else if(elem.hasAttribute('product-id')){
            products[elem.getAttribute('product-id')] = elem.getAttribute('product-id');
       }else if (typeof meta != "undefined" && typeof meta.product != "undefined" && typeof meta.product.id != "undefined" || typeof window.WIDEREVIEW_META != "undefined" && typeof window.WIDEREVIEW_META.product != "undefined" && typeof window.WIDEREVIEW_META.product.id != "undefined") {
            products[(window.meta || window.WIDEREVIEW_META).product.id] = (window.meta || window.WIDEREVIEW_META).product.id;
       }
    });

    return {rate: Object.keys(products).join(',')};
}

async function renderRate() {
	if (window.WIDEREVIEW.options.enabled === false ) return;
	if (window.WIDEREVIEW.options.enabled_product_page_stars == false) return;

    addRateParentFlexWrap();
	renderCSS(window.WIDEREVIEW.options);
	implantRate(window.WIDEREVIEW);
}

function preRenderMini() {
	let miniContainers = document.querySelectorAll('.widereview-mini');
	let appContainer;
	let manualAdding = false;
	if (miniContainers.length < 1) return {};

	miniContainers = excludeMiniContainers (miniContainers);

	appContainer = checkMiniManualAdding (miniContainers);
	if ( typeof appContainer !== typeof undefined) {
		manualAdding = true;
	}

	if (manualAdding === false ) {
        appContainer  = createMiniAutomaticAdding (miniContainers);
	}

	window.WIDEREVIEW.Containers.Mini = appContainer;

    if (typeof appContainer == "undefined") return {};

	return {mini: determLocation (appContainer)};
}

async function renderMini() {

	if (window.WIDEREVIEW.options.enabled === false ) return;

	if (typeof meta != "undefined") {
		if (meta.page.pageType === 'collection') return;
	}

    if (typeof window.WIDEREVIEW_META != "undefined") {
        if (window.WIDEREVIEW_META.page.pageType === 'collection') return;
    }

	if (window.WIDEREVIEW.options.enabled_widereview_mini && window.WIDEREVIEW.options.enabled_widereview_mini === true) {
        addOverflowForminiParent()

		renderCSS(window.WIDEREVIEW.options);

		renderElementsMiniContainer(window.WIDEREVIEW.Containers.Mini, window.WIDEREVIEW.render.Mini.reviews, window.WIDEREVIEW.options);
		implantAppMini(window.WIDEREVIEW.Containers.Mini, window.WIDEREVIEW); // второй параметр там не используется
		initSwiper(window.WIDEREVIEW.Containers.Mini, null, window.WIDEREVIEW.options);

	}
}

function preRenderPack() {
	let appContainer, product_id;

	if (document.getElementById('widereview-pack') != null) {
		appContainer = document.getElementById('widereview-pack');
	} else if (document.getElementById('widereview-grid') != null) {
        appContainer = document.getElementById('widereview-grid');
    } else {
		return {};
	}

	if (!appContainer) return {};

    product_id = determLocation (appContainer);

	window.WIDEREVIEW.Containers.Pack = appContainer;

    window.WIDEREVIEW.url_get_form = getUrlApp () + '/api/get_form?product_id=' + window.WIDEREVIEW.form_product_id + '&shop=' + window.WIDEREVIEW.shop + '&shop_domain=' + window.location.hostname;

    return {pack: product_id};
}

async function renderPack() {

    if (window.WIDEREVIEW.options.enabled === false ) return;
    if (window.WIDEREVIEW.options.enabled_grid_pack === false) return;

	renderCSS(window.WIDEREVIEW.options);

	renderElementsPackContainer(window.WIDEREVIEW.Containers.Pack, window.WIDEREVIEW.render.Pack.reviews, window.WIDEREVIEW.options);
	watchEventPackHiddenReviews(window.WIDEREVIEW.render.Pack.reviews, window.WIDEREVIEW.options);
	adaptPackImg(window.WIDEREVIEW.Containers.Pack);
	if (window.WIDEREVIEW.render.Pack.reviews.length > 0) {
        setTimeout(function () {
            initMasonry();
        }, 1000);
    }
    renderForm(window.WIDEREVIEW.Containers.Pack, window.WIDEREVIEW.options, window.WIDEREVIEW);

	window.addEventListener('resize', function (evt) {
        if (window.WIDEREVIEW.render.Pack.reviews.length > 0) {
            initMasonry();
        }
	});
}

function preRenderSchemaorg() {
    if (typeof window.Shopify.visualPreviewMode != "undefined" && window.Shopify.visualPreviewMode == true) return {};
    if (typeof meta != "undefined" && meta.page.pageType !== 'product') return {};
    if (typeof window.WIDEREVIEW_META != "undefined" && window.WIDEREVIEW_META.page.pageType !== 'product') return {};

    return {schemaorg: (window.meta || window.WIDEREVIEW_META).product.id};
}

async function renderSchemaorg() {
    if (window.Shopify && window.Shopify.designMode === true) return;
    if (window.WIDEREVIEW.options.enabled === false) return;
    if (window.WIDEREVIEW.options.enabled_product_page_stars === false) return;
    if (window.WIDEREVIEW.render.Schemaorg.reviews.length === 0) return;
    if (typeof meta != "undefined" && meta.page.pageType !== 'product') return;
    if (typeof window.WIDEREVIEW_META != "undefined" && window.WIDEREVIEW_META.page.pageType !== 'product') return;

    const reviews = window.WIDEREVIEW.render.Schemaorg.reviews;
    const fetchUrl = new URL(window.location.href);
    fetchUrl.pathname += ".json";
    fetchUrl.search = "";

    try {
        const response = await fetch(fetchUrl);
        const productData = await response.json();
        if (response.status !== 200 || !productData.product) return;

        let schema = {
            "@context": "https://schema.org",
            "@type": "Product",
            aggregateRating: {
                "@type": "AggregateRating",
                ratingValue: window.WIDEREVIEW.render.Schemaorg.rate,
                reviewCount: reviews.length,
            },
            name: productData.product.title,
            description: productData.product.body_html,
            offers: {
                "@type": "Offer",
                availability: "https://schema.org/InStock",
            },
            review: [],
        };

        if (productData.product.image && productData.product.image.src) {
            schema.image = productData.product.image.src;
        }

        if (productData.product.variants.length > 0) {
            schema.offers.price = productData.product.variants[0].price;
            schema.offers.priceCurrency = window.Shopify.currency.active;
        }

        for (let i = 0; i < reviews.length; i++) {
            const review = reviews[i];

            schema.review.push({
                "@type": "Review",
                author: {
                    "@type": "Person",
                    name: review.name || "User",
                },
                name: review.name || "User",
                datePublished: review.created_at,
                reviewBody: review.text,
                reviewRating: {
                    "@type": "Rating",
                    ratingValue: review.rate,
                    bestRating: 5,
                    worstRating: 1,
                }
            });
        }

        const scriptTag = document.createElement("script");
        scriptTag.type = "application/ld+json";
        scriptTag.setAttribute("data-widereview-schemaorg", "");
        scriptTag.text = JSON.stringify(schema);

        document.body.appendChild(scriptTag);
    } catch (error) {
        console.error(error);
    }
}

function restoreFetch() {
    if (!window._restoredFetch) {
        const iframe = document.createElement('iframe');

        iframe.style.display = 'none';
        document.body.appendChild(iframe);

        window._restoredFetch = iframe.contentWindow.fetch;
    }

    return window._restoredFetch;
}

(function () {
    function init() {

		if(typeof window.originalFetch == typeof undefined){
			window.originalFetch = restoreFetch();
		}
		let dataForFetch = [];
		let url;

		['Carousel', 'Rate', 'Mini', 'Pack', 'Schemaorg'].forEach(function (el) {
			Object.assign(dataForFetch, eval('preRender' + el + '()'));
		});

		url = getUrlApp() + '/api/get_data?shop=' + window.WIDEREVIEW.shop;

		Object.keys(dataForFetch).forEach(ind => {
			url = url + '&' + ind + '=' + dataForFetch[ind];
		});

		window.originalFetch(url, {
            headers: {
                'Content-Type': 'application/json',
            },
            method: 'GET',
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                return response.json();
            })
            .then(function (data) {
				Object.assign(window.WIDEREVIEW, data);

				if(typeof window.WIDEREVIEW.render == typeof {}){

					setCookie(window.WIDEREVIEW.cookie);

					Object.keys(window.WIDEREVIEW.render).forEach(ind => {
						data = eval('render' + ind + '()');
					});

					setTimeout( () => observePageChanges(document), 1000);
				}
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    document.addEventListener("shopify:section:load", function (event) {
        return init();
    });

    return init();
})();

function debounce(f, ms) {
    let isCooldown = false;

    return function() {
        if (isCooldown) return;
        f.apply(this, arguments);
        isCooldown = true;
        setTimeout(() => isCooldown = false, ms);
    };
}

function observePageChanges(target) {
    const config = {
        childList: true,
        subtree: true
    };

    const callback = function(mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                debounce(renderRate(), 2000);
                break;
            }
        }
    };

    const observer = new MutationObserver(callback);
    observer.observe(target, config);
}

function excludeMiniContainers (miniContainers) {
    const exeptions = ['#featured-product-scroll', '.featured-products-wrapper'];
    let newArray = [];

    miniContainers.forEach(function (el) {
        let condition = false;
        for (let j = 0; j < exeptions.length; j++) {
            if (el.closest(exeptions[j])) {
                condition = true
            }
        }

        if (condition === false) {
            newArray.push(el);
        }
    });
    return newArray;
}

function checkMiniManualAdding (miniContainers) {
    let appContainer, product_id;
    for (let i = 0; i < miniContainers.length; i++) {
       if (!miniContainers[i].hasAttribute('data-tag')) {
           let miniApp = miniContainers[i];

           if (miniApp.hasAttribute('product-id')) {
               product_id = miniApp.getAttribute('product-id');
           } else if (typeof meta != "undefined" && typeof meta.product != "undefined" && typeof meta.product.id != "undefined" || typeof window.WIDEREVIEW_META != "undefined" && typeof window.WIDEREVIEW_META.product != "undefined" && typeof window.WIDEREVIEW_META.product.id != "undefined") {
               product_id = (window.meta || window.WIDEREVIEW_META).product.id;
           } else {
               product_id = '1';
           }

           miniApp.setAttribute('product-id', product_id);
           appContainer = miniApp;

           break;
       }
    };

    return appContainer;
}

function createMiniAutomaticAdding (miniContainers) {
    let appContainer, product_id;
    for (let i = 0; i < miniContainers.length; i++) {
        if (document.getElementById('new-form-atc') && document.getElementById('new-form')) {
            let form = document.getElementById('new-form').parentNode;
            let autoMini = form.querySelector('.widereview-mini');
            let parent = document.getElementById('new-form');
            if (!autoMini) return;

            appContainer = createNewMiniContainer (parent, autoMini);
            break;
        }
        else if (document.querySelector('div[data-label="(P) Cart Button"]')) {
            let neighbor = document.querySelector('div[data-label="(P) Cart Button"]');
            let form = neighbor.closest('form');
            if (!form) return;
            let autoMini = form.querySelector('.widereview-mini');

            appContainer = createNewMiniContainer (form, autoMini);
            break;

        } else {
            let parent_ = miniContainers[i].closest('form');
            let idParent;

            if (parent_ && parent_.hasAttribute('id')) {
                idParent = parent_.getAttribute('id').toLowerCase();
            }

            let ifStickyClass = false;

			const ignoreSticky = ['is--main-sticky'];
            for (let i = 0; i < parent_.classList.length; i++) {
                if (parent_.classList[i].toLowerCase().indexOf('sticky') !== -1 && ignoreSticky.indexOf(parent_.classList[i])==-1) {
                    ifStickyClass = true;
                    break;
                }
            }

            let shopifyPaymentTerms = parent_.querySelector('shopify-payment-terms');

            if (parent_ && typeof idParent != "undefined" && shopifyPaymentTerms && Array.from(parent_.children).filter(element => element.getBoundingClientRect().height > 0).length == 1) {
                continue;
            }

            if (parent_ && typeof idParent != "undefined" &&  parent_.clientHeight > 0 && idParent.indexOf('sticky') === -1 && ifStickyClass === false) {
                appContainer = miniContainers[i];
                break;
            }
        }
    }

    return appContainer;
}

function createNewMiniContainer (parent, autoMini) {
    let product_id;
    let miniApp = document.createElement('div');
    miniApp.classList.add('widereview-mini');

    if (autoMini.hasAttribute('widereview-mini-product-id')) {
        product_id = autoMini.getAttribute('widereview-mini-product-id');
    } else if (autoMini.hasAttribute('product-id')) {
        product_id = autoMini.getAttribute('product-id');
    } else if (typeof meta != "undefined" && typeof meta.product != "undefined" && typeof meta.product.id != "undefined" || typeof window.WIDEREVIEW_META != "undefined" && typeof window.WIDEREVIEW_META.product != "undefined" && typeof window.WIDEREVIEW_META.product.id != "undefined") {
        product_id = (window.meta || window.WIDEREVIEW_META).product.id;
    } else {
        product_id = '1';
    }

    miniApp.setAttribute('product-id', product_id);
    // neighbor.parentNode.insertBefore(miniApp, neighbor.nextSibling);
    parent.append(miniApp);
    return miniApp;
}

function getUrlApp () {

	if(typeof window.WIDEREVIEW.url_app == typeof undefined){
		let ind, url;
		let scripts = document.getElementsByTagName('script');
		let url_app = '';

		for(ind in scripts){
			if(typeof scripts[ind].src != typeof undefined && scripts[ind].src.indexOf('js/widereview.js')>0){
				url = new URL(scripts[ind].src);
				url_app = url.protocol + '//' + url.host;
			}
		}
		window.WIDEREVIEW.url_app = url_app;
	}

	if(typeof window.WIDEREVIEW.shop == typeof undefined){
		let shop = '';

		if (window.Shopify && window.Shopify.shop) {
			shop = Shopify.shop;
		} else {
			shop = window.location.hostname;
		}

		if (shop.indexOf('myshopify') === -1) {
			throw new Error('widereview app did not find correct shop name');
		}

		window.WIDEREVIEW.shop = shop;
	}

	if(typeof window.WIDEREVIEW.typeSourcePage == typeof undefined){
		//determ current page
		window.WIDEREVIEW.typeSourcePage = new URL(location.href);
		window.WIDEREVIEW.typeSourcePage = window.WIDEREVIEW.typeSourcePage.pathname.split('/')[1];
		if(window.WIDEREVIEW.typeSourcePage==''){
			window.WIDEREVIEW.typeSourcePage = 'homepage';
		}
	}
	return window.WIDEREVIEW.url_app;
}

function determLocation (appContainer) {

	let product_id;

	if (appContainer.hasAttribute('product-id')) {
		product_id = appContainer.getAttribute('product-id');
	} else if (appContainer.hasAttribute('widereview-mini-product-id')) {
		product_id = appContainer.getAttribute('widereview-mini-product-id');
	} else if (typeof meta != typeof undefined && typeof meta.product != typeof undefined && typeof meta.product.id != typeof undefined || typeof window.WIDEREVIEW_META != typeof undefined && typeof window.WIDEREVIEW_META.product != typeof undefined && typeof window.WIDEREVIEW_META.product.id != typeof undefined) {
		product_id = (window.meta || window.WIDEREVIEW_META).product.id;
	} else if (typeof meta == typeof undefined && document.getElementById('OnlineStoreEditorData')) {
		let editorDataScript = document.getElementById("OnlineStoreEditorData");
		let editorDataJson = editorDataScript.textContent;
		let editorData = JSON.parse(editorDataJson);

		if (editorData && editorData.template && editorData.template.resource && editorData.template.resource.gid) {
			product_id = editorData.template.resource.gid.split("/Product/")[1];
		}
	} else {
		product_id = 1;
	}

	if(product_id == null && typeof meta != typeof undefined && typeof meta.product != typeof undefined && typeof meta.product.id != typeof undefined || product_id == null && typeof window.WIDEREVIEW_META != typeof undefined && typeof window.WIDEREVIEW_META.product != typeof undefined && typeof window.WIDEREVIEW_META.product.id != typeof undefined){
		product_id = (window.meta || window.WIDEREVIEW_META).product.id;
	}
	if(product_id == null){
		product_id = 1;
	}

	if (appContainer.hasAttribute('form-product-id') && appContainer.getAttribute('form-product-id')!=='all') {
		window.WIDEREVIEW.form_product_id = appContainer.getAttribute('form-product-id');
	}else{
		window.WIDEREVIEW.form_product_id = 1;
		if (appContainer.hasAttribute('product-id') && appContainer.hasAttribute('product-id')>1) {
			window.WIDEREVIEW.form_product_id = appContainer.getAttribute('product-id');
		} else if (typeof meta != typeof undefined && typeof meta.product != typeof undefined && typeof meta.product.id != typeof undefined || typeof window.WIDEREVIEW_META != typeof undefined && typeof window.WIDEREVIEW_META.product != typeof undefined && typeof window.WIDEREVIEW_META.product.id != typeof undefined) {
			window.WIDEREVIEW.form_product_id = (window.meta || window.WIDEREVIEW_META).product.id;
		} else if (typeof meta == typeof undefined && document.getElementById('OnlineStoreEditorData')) {
			let editorDataScript = document.getElementById("OnlineStoreEditorData");
			let editorDataJson = editorDataScript.textContent;
			let editorData = JSON.parse(editorDataJson);

			if (editorData && editorData.template && editorData.template.resource && editorData.template.resource.gid) {
				window.WIDEREVIEW.form_product_id = editorData.template.resource.gid.split("/Product/")[1];
			}
		}
	}

    return product_id;
}

plugWeglot();
}
